import { useCallback, useMemo } from 'react';
import { useClient } from '../../../../../context/client';
import { useCustomerGroup } from '../../../context';
import {
	setProductNamesWithColor,
	setSelectedColor,
	setSelectedProductName,
	setSelectedProductType,
} from '../../../store/productsSearchSlices/productFiltersSlice';
import { setIsLoading } from '../../../store/productsSearchSlices/searchSlice';
import ColorSwatch from './ColorSwatch';
import styles from './ColorSwatch.module.css';
import { ProductFilterSelect } from './ProductFilterSelect';

export function ProductFiltersSelection({ filters, filtersDispatch }) {
	const [customerGroup] = useCustomerGroup();
	const client = useClient();
	const onProductTypeChange = useCallback(
		async (selectedProductType) => {
			filtersDispatch(setSelectedProductType(selectedProductType));

			if (
				!filters.vehicle.year.selected ||
				!filters.vehicle.make.selected ||
				!filters.vehicle.model.selected
			)
				return;

			const subModel = filters.vehicle.subModel.selected;

			const searchParams = {
				year: filters.vehicle.year.selected,
				make: filters.vehicle.make.selected,
				model: filters.vehicle.model.selected,
				product_type: selectedProductType,
			};

			filtersDispatch(setIsLoading(true));

			if (subModel) searchParams.subModel = subModel;

			const productNamesWithColor = await client.getProductNamesAndColors(
				searchParams,
			);

			filtersDispatch(setProductNamesWithColor(productNamesWithColor));
			filtersDispatch(setIsLoading(false));
		},
		[filters],
	);

	const colorOptions = useMemo(
		() =>
			filters.product.color.options.map((option) => {
				// Get the correct colorSwatchData using the Selected Product Name
				const colorSwatchData =
					filters.product.productName.colorOptionsByName[
						filters.product.productName.selected
					].find((colorOption) => colorOption.label === option.value);
				const [backGroundColorSwatch, midColorSwatch = 'none'] =
					colorSwatchData.colorData;
				return {
					...option,
					description: (
						<ColorSwatch
							backGroundColorSwatch={backGroundColorSwatch}
							midColorSwatch={midColorSwatch}
							colorSwatchData={colorSwatchData}
						/>
					),
				};
			}),
		[filters.product.productName.selected],
	);
	return (
		<>
			<ProductFilterSelect
				availableText="Product Type"
				parentSelection={true}
				onOptionChange={onProductTypeChange}
				value={filters.product.productType.selected}
				options={filters.product.productType.options}
				disabled={!customerGroup}
			/>
			<ProductFilterSelect
				availableText="Product Name"
				unavailableText="No Products Available"
				onOptionChange={(data) =>
					filtersDispatch(setSelectedProductName(data))
				}
				parentSelection={filters.product.productType.selected}
				value={filters.product.productName.selected}
				options={filters.product.productName.options}
			/>
			<ProductFilterSelect
				wrapperClass={styles.colorFilterSelect}
				availableText="Colors"
				unavailableText="No Colors Available"
				onOptionChange={(data) => {
					filtersDispatch(setSelectedColor(data));
				}}
				parentSelection={filters.product.productName.selected}
				value={filters.product.color.selected}
				options={colorOptions}
			/>
		</>
	);
}
